import React from 'react';
import PropTypes from 'prop-types';

import * as service from '../../utils/service';

const hgmdBaseurl = service.hgmdBaseurl();

const Footer = () => {
  return (
    <div className="bg-deep-blue-70">
      <div className="flex flex-col px-6 py-12 md:px-[112px] md:py-8 gap-5">
        <div className="w-full md:w-[20%] md:inline-block">
          <img
            src="/public/images/healthgrades-logo-footer-white.svg"
            alt="Healthgrades"
            className="h-auto relative right-[0.02%] md:left-0"
          />
        </div>
        <div className="w-full text-xs mt-[3px] text-white font-sans md:h-auto md:inline-block md:w-full md:mt-2.5">
          <div className="block relative font-sans text-sm leading-[21px] text-white w-full md:top-0 md:h-auto md:text-base">
            <a
              href="https://www.healthgrades.com/"
              target="_blank"
              rel="noreferrer"
              className="text-white text-base font-bold hover:underline mr-2"
            >
              Healthgrades.com
            </a>
            <span className="text-white text-lg mr-2">|</span>
            <a
              href="https://www.healthgrades.com/about"
              target="_blank"
              rel="noreferrer"
              className="text-white text-base font-bold hover:underline mr-2"
            >
              About Us
            </a>
            <span className="text-white text-lg mr-2">|</span>
            <a
              href={`${hgmdBaseurl}contactus`}
              target="_blank"
              rel="noreferrer"
              className="text-white text-base font-bold hover:underline mr-2"
            >
              Contact Us
            </a>
            <span className="text-white text-lg mr-2">|</span>
            <a
              href="https://www.healthgrades.com/content/legal-disclaimer"
              target="_blank"
              rel="noreferrer"
              className="text-white text-base font-bold hover:underline mr-2"
            >
              Legal Disclaimer
            </a>
            <span className="text-white text-lg mr-2">|</span>
            <a
              href="https://www.healthgrades.com/content/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className="text-white text-base font-bold hover:underline mr-2"
            >
              Privacy Policy
            </a>
            <span className="text-white text-lg mr-2">|</span>
            <a
              href="/?policy=terms-of-service"
              target="_blank"
              rel="noreferrer"
              className="text-white text-base font-bold hover:underline mr-2"
            >
              Terms of Service
            </a>
            <span className="text-white text-lg mr-2">|</span>
            <a
              href="https://helpcenter.healthgrades.com/help?utm_source=hgmd&utm_medium=footer&utm_campaign=help-center"
              target="_blank"
              rel="noreferrer"
              className="text-white text-base font-bold hover:underline"
            >
              Help Center
            </a>
          </div>
          <p className="pb-4 pt-4 pr-12 text-xs leading-4 text-white md:pr-0 font-thin">
            Copyright 2025 Healthgrades Marketplace, LLC, Patent US Nos.
            7,752,060 and 8,719,052. All Rights Reserved. <br />
            Healthgrades is an RVO Health company. Third Party materials
            included herein protected under copyright law.
          </p>
          <p className="font-sans font-thin text-xs leading-4 text-white md:pr-0 md:mb-4">
            Use of this website and any information contained herein is governed
            by the{' '}
            <a
              href="https://update.healthgrades.com/user-agreement"
              target="_blank"
              rel="noreferrer"
              className="text-white no-underline hover:underline"
            >
              Healthgrades Physician User Agreement
            </a>{' '}
            Misrepresenting yourself as a physician violates federal statutes
            and laws in all 50 states. Only physicians or their authorized
            representatives are allowed to manage the physician's profile on
            Company. Violators will be prosecuted to the fullest extent of the
            law.
          </p>
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  footer: PropTypes.object,
};
export default Footer;
